export const setupReminderExplanation = {
  en: {
    "user.setup.reminder.explanation": "We’ll send you reminders for upcoming bdays",
  },
  es: {
    "user.setup.reminder.explanation": "Te enviaremos recordatorios para los próximos cumpleaños",
  },
};
